import { render, staticRenderFns } from "./editServiceRule.vue?vue&type=template&id=83db4c7e&scoped=true"
import script from "./editServiceRule.vue?vue&type=script&lang=js"
export * from "./editServiceRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83db4c7e",
  null
  
)

export default component.exports